import React from "react";

import OrderForm from './orderForm.js';
import Payment from './payment.js';

export default function OrderDetail({ order, setOrder }) {

    return order?._id ? <Payment order={order} setOrder={setOrder} /> : <OrderForm setOrder={setOrder} />;
}